
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import CaseStudies from './components/CaseStudies';
import PricingPlans from './components/PricingPlans';
import InitialCost from './components/InitialCost';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import SchemaOrg from '../../components/SchemaOrg';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="Service" />
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Benefits />
      <PricingPlans />
      <InitialCost />
      <CaseStudies />
      <ContactForm />
      <Footer />
    </div>
  );
}
